import { isValidElement } from "react";
import { isTamaguiComponent } from "./isTamaguiComponent";
const isTamaguiElement = (child, name) => {
  return isValidElement(child) && isTamaguiComponent(child.type, name);
};
export {
  isTamaguiElement
};
//# sourceMappingURL=isTamaguiElement.js.map
